import { Injectable, Inject } from '@angular/core';
import { DocumentTypes } from 'ep-bt-controls';
import { FieldAgentClient, FieldagentClientExtension, API_BASE_URL, DocumentRequestParameters, DocumentRequestParametersDocumentType, AbstractDocument, DocumentRequestHandle, IDocumentRequestParameters } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { BistrackConfig, ErrorStatus } from 'ep-bt-controls';
import { EpLocalStorageService, EpEventService } from '@epicor/kinetic';
import { HttpClient } from '@angular/common/http';
import { EpbtFieldAgentService } from './epbt-field-agent.service';
import { EpDialogService } from '@epicor/kinetic';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaAttachmentService {

  private http: HttpClient;
  private baseUrl: string;

  bistrackSettings: any;
  webTrackUser: any;
  documentRequestParameters: DocumentRequestParameters;
  resDocReqHandle: DocumentRequestHandle;
  public IsIncludePaidTransactions: boolean = false;

  dialog: any;
  private maxRetries = 5;
  private retryInterval = 6000; // millisecond


  constructor(@Inject(HttpClient) http: HttpClient, @Inject(API_BASE_URL) baseUrl: string, private client: FieldAgentClient,
    private router: Router, private config: BistrackConfig,
    private localStorageService: EpLocalStorageService,
    public epEvent: EpEventService, private faService: EpbtFieldAgentService, private faClientExtension: FieldagentClientExtension) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : "";

    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
    });

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
  }

  processPDFDocumentForDownload(documentType: string, selectedDataItems: any) {
    switch (documentType) {
      case DocumentTypes.Quotes:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.Quote, selectedDataItems.orderId);
          break;
        }
      case DocumentTypes.Orders:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.Order, selectedDataItems.orderId);
          break;
        }
      case DocumentTypes.Invoices:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.Invoice, selectedDataItems.invoiceId);
          break;
        }
      case DocumentTypes.Credits:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.CreditNote, selectedDataItems.creditNoteId);
          break;
        }
      case DocumentTypes.Statements:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.Statement, selectedDataItems.statementId);
          break;
        }
      case DocumentTypes.Stocktransfers:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.StockTransfer, selectedDataItems.orderId);
          break;
        }
      case DocumentTypes.PurchaseOrder:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.PurchaseOrder, selectedDataItems.purchaseOrderID);
          break;
        }
      case DocumentTypes.WorkOrders:
        {
          this.getDataFromApi(DocumentRequestParametersDocumentType.WorksOrder, selectedDataItems.worksOrderId);
          break;
        }
      default:
        {
          break;
        }
    }
  }

  getDataFromApi(documentType: DocumentRequestParametersDocumentType, documentId: number) {
    this.documentRequestParameters = new DocumentRequestParameters();
    this.documentRequestParameters = this.getDocumentRequestParameters(documentType, documentId);

    this.dialog = EpDialogService.progress({ message: 'PDF', description: 'Downloading...' });
    //requestDocumentProcessingBTCloud Api
    this.client.requestDocumentProcessingBTCloud(this.documentRequestParameters).subscribe(res => {
      if (res != null) {
        this.resDocReqHandle = res;
        if (this.resDocReqHandle.failed) {
          this.faService.displayToastMessage("PDF", "The document service failed to process " + documentType + " document.", ErrorStatus.Error);
          this.dialog.close();
        }
        else {
          setTimeout(() => {
            try {
              this.downloadFile(documentType);
            }
            catch (ex) {
              console.log("PDF Error", ex);
              this.dialog.close();
            }
          }, 1300);
        }
      }
    });
  }

  getDocumentRequestParameters(documentType: DocumentRequestParametersDocumentType, documentId: number): DocumentRequestParameters {
    const iDocumentRequestParameters: IDocumentRequestParameters = { documentId: documentId };
    let documentRequestParameters = new DocumentRequestParameters(iDocumentRequestParameters);
    documentRequestParameters.requestingUser = this.webTrackUser;
    documentRequestParameters.documentIds = [documentId];
    documentRequestParameters.documentType = documentType;
    documentRequestParameters.processDocument = true;
    if (documentRequestParameters.documentType == DocumentRequestParametersDocumentType.Statement) {
      if (this.IsIncludePaidTransactions)
        documentRequestParameters.statementIncludePaidTransactions = true;
      else
        documentRequestParameters.statementIncludePaidTransactions = false;
      documentRequestParameters.isSummaryStatement = false;
    }
    else {
      documentRequestParameters.statementIncludePaidTransactions = false;
      documentRequestParameters.isSummaryStatement = false;
    }
    documentRequestParameters.statementByJob = false;
    documentRequestParameters.statementSortByJob = false;
    documentRequestParameters.statementFromDate = new Date();//this.bistrackSettings.shortDateFormat;
    return documentRequestParameters;
  }

  //Downloads the file and with retries
  downloadFile(documentType) {
    let queueId = 0;

    this.requestdownloadfileWithRetry(queueId, this.maxRetries, this.retryInterval).then((resBlob) => {
      if (resBlob) {
        const blob = new Blob([resBlob], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        this.dialog.close();
      }
      else {
        this.dialog.close();
        this.faService.displayToastMessage("PDF", "File Not Found" + documentType + " document.", ErrorStatus.Error);
      }
    });
  }

  requestdownloadfileWithRetry(queueId: number, retry: number, interval: number): Promise<any> {
    return new Promise(resolve => {
      this.faClientExtension.downloadFile(this.resDocReqHandle.retrievalParameters.documentPath).subscribe(resStatus => {
        console.log(resStatus, "ressatus")
        if (resStatus) {
          resolve(resStatus);
        } else {
          retry--;
          if (retry < 1) {
            resolve(resStatus);
          }
          else {
            setTimeout(() => {
              this.requestdownloadfileWithRetry(queueId, retry, interval).then((result) => {
                if (result) {
                  resolve(result);
                }
              });
            }, interval);
          }
        }
      });
    });
  }
}
